import React from "react";
import { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import SvgIcon from "@material-ui/core/SvgIcon";
import { alpha, makeStyles, withStyles } from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem, { useTreeItem } from "@material-ui/lab/TreeItem";
import clsx from "clsx";
import TreeItemContentProps from "@material-ui/lab/TreeItem";

import Collapse from "@material-ui/core/Collapse";
import { useSpring, animated } from "@react-spring/web"; // web.cjs is required for IE 11 support

import useMounted from "../hooks/useMounted";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Auth } from "aws-amplify";
import config from "../config";

import eventBus from "../EventBus";
import Scrollbar from "../components/Scrollbar";

import { contactFlowApi } from "../__fakeApi__/amazon_connect_logs";

import {
  Modal,
  Box,
  Fade,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Link,
  Card,
} from "@material-ui/core";

function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

function CloseSquare(props) {
  return (
    <SvgIcon
      className="close"
      fontSize="inherit"
      style={{ width: 14, height: 14 }}
      {...props}
    >
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
    </SvgIcon>
  );
}

const CustomContent = React.forwardRef(function CustomContent(props, ref) {
  const {
    classes,
    className,
    label,
    nodeId,
    icon: iconProp,
    expansionIcon,
    displayIcon,
    message,
  } = props;

  const {
    disabled,
    expanded,
    selected,
    focused,
    handleExpansion,
    handleSelection,
    preventSelection,
  } = useTreeItem(nodeId);

  const icon = iconProp || expansionIcon || displayIcon;

  const handleMouseDown = (event) => {
    preventSelection(event);
  };

  const handleExpansionClick = (event) => {
    handleExpansion(event);
  };

  const handleSelectionClick = (event) => {
    handleSelection(event);
    setOpen(true);
  };

  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);

  function replacer(key, value) {
    if (key == "SubMessages") return undefined;
    else return value;
  }

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions

    <div
      className={clsx(className, classes.root, {
        [classes.expanded]: expanded,
        [classes.selected]: selected,
        [classes.focused]: focused,
        [classes.disabled]: disabled,
      })}
      onMouseDown={handleMouseDown}
      ref={ref}
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div onClick={handleExpansionClick} className={classes.iconContainer}>
        {icon}
      </div>

      {["Disconnect", "MOREINTHISLIST"].includes(
        message.message.ContactFlowModuleType
      ) ||
      ("Results" in message.message &&
        message.message.Results.includes("Error")) ? (
        <Typography
          sx={{ color: "red" }}
          onClick={handleSelectionClick}
          component="div"
          className={classes.label}
        >
          {label}
        </Typography>
      ) : (
        <Typography
          onClick={handleSelectionClick}
          component="div"
          className={classes.label}
        >
          {label}
        </Typography>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper variant="outlined">
          <pre style={{ whiteSpace: "pre-wrap" }}>
            {/* TODO to not sho SubMessages in Transfer message */}
            {["Transfer", "InvokeFlowModule"].includes(
              message.message.ContactFlowModuleType
            )
              ? JSON.stringify(message.message, replacer, 2)
              : JSON.stringify(message.message, null, 2)}
          </pre>
        </Paper>
      </Modal>
    </div>
  );
});

CustomContent.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object.isRequired,
  /**
   * className applied to the root element.
   */
  className: PropTypes.string,
  /**
   * The icon to display next to the tree node's label. Either a parent or end icon.
   */
  displayIcon: PropTypes.node,
  /**
   * The icon to display next to the tree node's label. Either an expansion or collapse icon.
   */
  expansionIcon: PropTypes.node,
  /**
   * The icon to display next to the tree node's label.
   */
  icon: PropTypes.node,
  /**
   * The tree node label.
   */
  label: PropTypes.node,
  /**
   * The id of the node.
   */
  nodeId: PropTypes.string.isRequired,
};

function CustomTreeItem(props) {
  return <TreeItem ContentComponent={CustomContent} {...props} />;
}

const CustomContentXX = React.forwardRef(function CustomContent(props, ref) {
  const { message } = props;
  console.log(message); // undefined

  return (
    <div ref={ref}>
      <Box sx={{ p: 1 }}>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            {[
              "Disconnect",
              "TransferContactToQueue",
              "TransferParticipantToThirdParty",
            ].includes(message.ContactFlowModuleType) ? (
              <Typography sx={{ color: "red" }}>
                {message.ContactFlowModuleType}
              </Typography>
            ) : (
              <Typography sx={{ color: "green" }}>
                {message.ContactFlowModuleType}
              </Typography>
            )}
          </AccordionSummary>
          <AccordionDetails>
            <Paper variant="outlined" sx={{ width: 500 }}>
              <pre style={{ whiteSpace: "pre-wrap" }}>
                {JSON.stringify(message, null, 2)}
              </pre>
            </Paper>
          </AccordionDetails>
        </Accordion>
      </Box>
    </div>
  );
});

function TransitionComponent(props) {
  const style = useSpring({
    from: { opacity: 0, transform: "translate3d(20px,0,0)" },
    to: {
      opacity: props.in ? 1 : 0,
      transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
    },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
}

TransitionComponent.propTypes = {
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
};

const StyledTreeItem = withStyles((theme) => ({
  iconContainer: {
    "& .close": {
      opacity: 0.3,
    },
  },
  group: {
    marginLeft: 7,
    paddingLeft: 18,
    borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
  },
}))((props) => (
  <CustomTreeItem {...props} TransitionComponent={TransitionComponent} />
));

const useStyles = makeStyles({
  root: {
    height: 264,
    flexGrow: 1,
    maxWidth: 400,
  },
});

function SubStyledTreeItem(props) {
  const { cMessages } = props;


  // Similar to componentDidMount and componentDidUpd
  useEffect(() => {
    try {
      eventBus.on("newExecutionConnect", (data) => {
        //setcMessages([])
        eventBus.remove("newExecutionConnect");
      });
    } catch (err) {
      console.error(err);
    }
  }, [eventBus.on]);


  return cMessages.slice().reverse().map((message, index) =>
    ["Transfer", "InvokeFlowModule"].includes(message.ContactFlowModuleType) ? (
      <StyledTreeItem
        nodeId={Math.floor(Math.random() * 10000000).toString()}
        label={message.ContactFlowModuleType + "~" +  message.Timestamp} 
        key={message.Timestamp + "-" + Math.floor(Math.random() * 10000)}
        ContentProps={{
          message: { message },
        }}
      >
        <SubStyledTreeItem
          cMessages={message.SubMessages}
          key={message.Timestamp + "-" + Math.floor(Math.random() * 10000)}
        />
      </StyledTreeItem>
    ) : (
      <StyledTreeItem
        nodeId={Math.floor(Math.random() * 10000000).toString()}
        label={message.ContactFlowModuleType + '~' +  message.Timestamp}
        key={message.Timestamp + "-" + Math.floor(Math.random() * 10000)}
        ContentProps={{
          message: { message },
        }}
      />
    )
  );
}

export default function CustomizedTreeView(props) {
  // const {
  //   connectMessages
  // } = props;
  const mounted = useMounted();
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const [openAll, setOpenAll] = React.useState(false);
  const handleCloseAll = () => setOpenAll(false);
  const handleOpenAll = () => setOpenAll(true);

  const wsConnect = async () => {
    const user = await Auth.currentAuthenticatedUser({
      bypassCache: false, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    });
    setWsAmazonConnect(
      new WebSocket(
        config.WEBSOCKET_AMAZON_CONNECT + "?userId=" + user.username
      )
    );
  }


  const [subFlows, setSubFlows] = useState(new Map());
  const [connectMessages, setConnectMessages] = useState([]);
  const [wsAmazonConnect, setWsAmazonConnect] = useState(wsConnect);

 


  useEffect(() => {
    wsAmazonConnect.onopen = () => {
      console.log("WebSocket Connected");
      // ws.send('client says hi ......');
    };

    wsAmazonConnect.onmessage = (e) => {
      const message = JSON.parse(e.data);
      console.log("message received ...", message);

      if (
        connectMessages.length == 0 ||
        connectMessages[connectMessages.length - 1].ContactFlowId ===
          message.ContactFlowId
        // fist message of the flow or first message of the subflow
      ) {
        // incoming magges is in the main flow
        setConnectMessages([message, ...connectMessages]);
      } else {
        // incoming magges is a sub flows
        if (message.ContactFlowModuleType === "Transfer") {
          message.SubMessages = [];
          // setSubFlows( subFlows.set(message.ContactFlowId, message));
          // setSubFlows( [message.ContactFlowId, message], ...subFlows);
          subFlows.set(message.ContactFlowId, message)
          setConnectMessages([message, ...connectMessages]);
        } else if (message.ContactFlowModuleType === "InvokeFlowModule") {
          // ContactFlowId changes in the following messages
          message.SubMessages = [];
          let  flowIdForFollowingMessages = message.ContactFlowId.split('contact-flow')[0] + 'flow-module/' + message.Parameters.FlowModuleId
          // setSubFlows(subFlows.set(flowIdForFollowingMessages, message));
          // setSubFlows( [flowIdForFollowingMessages, message], ...subFlows);
          subFlows.set(flowIdForFollowingMessages, message);
          setConnectMessages([message, ...connectMessages]);
        } else {
          // incoming magges is in a sub flows
          let flow = subFlows.get(message.ContactFlowId);
          if (flow) {
            subFlows.get(message.ContactFlowId).SubMessages.unshift(message);
            // setSubFlows(subFlows);
          } else {
            console.log(
              "no flow found for the message " + message.ContactFlowId
            );
          }
        }
      }
    };

    return () => {
      wsAmazonConnect.onclose = () => {
        console.log("Amazon WebSocket Disconnected.. re-connecting");
        // setWsAmazonConnect(new WebSocket(config.WEBSOCKET_AMAZON_CONNECT));
        // re-open the connection if it closes
        setTimeout(function() {
          wsConnect();
        }, 10);
      };
    };

    //getMockMessages();
  }, [
    //getMockMessages,
    wsAmazonConnect.onmessage,
    wsAmazonConnect.onopen,
    wsAmazonConnect.onclose,
    connectMessages,
  ]);

  if (connectMessages && connectMessages.length > 0) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Typography color="green" variant="h12" onClick={handleOpenAll}>
          <Link color="green" onClick={handleOpenAll}>
            Click here to see all logs
          </Link>
        </Typography>

        <Modal
          open={openAll}
          onClose={handleCloseAll}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <Scrollbar options={{ suppressScrollX: true }}>
              <Card>
                Press ESC to exit ...
                {connectMessages
                  .slice()
                  .reverse()
                  .map((message, index) => (
                    <pre style={{ whiteSpace: "pre-wrap" }} key={index}>
                      {JSON.stringify(message, null, 2)}
                    </pre>
                  ))}
              </Card>
            </Scrollbar>
          </Box>
        </Modal>

        <Scrollbar
          options={{ suppressScrollX: true }}
          sx={{
            height: "100%",
          }}
        >
          <TreeView
            className={classes.root}
            defaultExpanded={["1"]}
            defaultCollapseIcon={<MinusSquare />}
            defaultExpandIcon={<PlusSquare />}
            defaultEndIcon={<CloseSquare />}
          >
            <SubStyledTreeItem cMessages={connectMessages} />
          </TreeView>
        </Scrollbar>
      </Box>
    );
  } else {
    return <TreeView />;
  }
}
